import React from 'react';
import Currency from '../Currency';
import IHasItemDataProps from './IHasItemDataProps';
import IHasLinkProps from './IHasLinkProps';
import { ModalTriggerButton } from '../Modals/ModalTriggerButton';
import { eSingleFields } from '../context/state/eSingleFields';
import { ILoanAmountViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { convertToFloat } from '../../../ui-toolkit/utilities/convertToFloat';

interface ILoanAmountProps extends IHasItemDataProps<ILoanAmountViewItem>, IHasLinkProps {}

/*tslint:disable-next-line:variable-name*/
const LoanAmount = (props: ILoanAmountProps) => {
  return (
    <div className="cost-data__row cost-data__aligned-row">
      <div className="cost-data__content-cell cost-data__content-row-number" />
      <div className="cost-data__content-cell cost-data__content-name">Loan Amount</div>
      <div className="cost-data__content-cell cost-data__content-amount cost-data__content-amount--text-content">
        <ModalTriggerButton fieldName={eSingleFields.loan_amount} disabled={!props.hasEditPermissions}>
          <Currency value={convertToFloat(props.data.buyer_at_closing)} />
        </ModalTriggerButton>
      </div>
      <div className="cost-data__content-cell cost-data__content-control" />
    </div>
  );
};

export default LoanAmount;
